export default function EFPlay(props: any) {
    return (
        <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="1月5号版本" stroke="none" fill="none" fillRule="evenodd">
                <g transform="translate(-779.000000, -683.000000)" fillRule="nonzero" id="-mockplus-">
                    <g transform="translate(643.000000, 680.000000)">
                        <g id="01-1视频播放button备份" transform="translate(136.000000, 3.000000)">
                            <path
                                d="M9,0.75 C11.2781746,0.75 13.3406746,1.67341269 14.8336309,3.16636902 C16.3265873,4.65932538 17.25,6.72182539 17.25,9 C17.25,11.2781746 16.3265873,13.3406746 14.833631,14.833631 C13.3406746,16.3265873 11.2781746,17.25 9,17.25 C6.72182536,17.25 4.65932536,16.3265873 3.16636902,14.833631 C1.67341268,13.3406746 0.75,11.2781746 0.75,9 C0.75,6.7218254 1.67341268,4.65932539 3.16636903,3.16636904 C4.65932537,1.67341269 6.72182537,0.75 9,0.75 Z"
                                id="路径"
                                stroke="#2673FF"
                                strokeWidth="1.5"
                            ></path>
                            <path
                                d="M7.05661808,4.90909091 C6.77430961,4.90909091 6.54545455,5.13794659 6.54545455,5.42025444 L6.54545455,5.42025444 L6.54545455,12.579673 C6.54545455,12.6739943 6.57155149,12.7664765 6.62085832,12.8468841 C6.76843532,13.0875474 7.08316587,13.1630092 7.32382881,13.0154326 L7.32382881,13.0154326 L13.1615085,9.43572328 C13.2301885,9.39360801 13.2879418,9.33585511 13.3300576,9.26717477 C13.4776335,9.02651142 13.4021725,8.71178077 13.1615085,8.56420418 L13.1615085,8.56420418 L7.32382881,4.98449489 C7.24342177,4.93518836 7.15093899,4.90909091 7.05661808,4.90909091 Z"
                                id="路径"
                                fill="#2673FF"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
